import {UGCReviewActionTypes} from './constants';

import {createAction} from '@stencil/hotels-types/src/type-guards';

export const updateUserReviews = (payload: {nextOta: string; reviews: any}) => {
  return createAction(UGCReviewActionTypes.UPDATE_USER_REVIEWS, payload);
};

export const updateReviewsSortBy = (payload: string) => {
  return createAction(UGCReviewActionTypes.UPDATE_REVIEWS_SORTBY, payload);
};

export function setReviewsLoadingState(payload: boolean) {
  return createAction(UGCReviewActionTypes.SET_USER_REVIEWS_LOADING_STATE, payload);
}

export function setIsUgcReviewV2(payload: boolean) {
  return createAction(UGCReviewActionTypes.SET_UGC_REVIEW_V2, payload);
}

export function resetUgcReviewV2() {
  return createAction(UGCReviewActionTypes.REST_UGC_REVIEW_V2);
}

export const updateGallerySelectedTab = (payload: string) => {
  return createAction(UGCReviewActionTypes.SET_SELECTED_GALLERY_TAB, payload);
};

export type UGCAction =
  | ReturnType<typeof updateUserReviews>
  | ReturnType<typeof updateReviewsSortBy>
  | ReturnType<typeof setIsUgcReviewV2>
  | ReturnType<typeof resetUgcReviewV2>
  | ReturnType<typeof setReviewsLoadingState>
  | ReturnType<typeof updateGallerySelectedTab>;
